import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import SectionHead from './SectionHead';
import Blog from './Blog';

const LatestPosts = () => (
  <section className="section">
    <div className="container">
      <div className="section-head-row">
        <SectionHead eyebrow="From the blog" title="Guides for schools and growing businesses" />
        <Link to="/blog" className="text-link">
          All articles <FiArrowRight />
        </Link>
      </div>
      <Blog limit={3} />
    </div>
  </section>
);

export default LatestPosts;
